export default __webpack_public_path__ + "static/media/property-placeholder.0caea818.png";